module.exports = __webpack_public_path__ + "static/media/mitarbeiter_richtig.8e4eb992.jpg";